import { CollectionUnion } from '../api/collections';
import { User } from '../api/user';

export const PROFILE_MANDATORY_FIELDS_TO_SUBMIT_KLYDO: (keyof User)[] = [
  'name',
  'country',
  'description',
  'photoUrl',
];

export const PROFILE_REQUIRED_FIELDS_FOR_STUDIO_REGISTRATION: (keyof User)[] = [
  'name',
];

export const COLLECTION_MANDATORY_FIELDS: (keyof CollectionUnion)[] = [
  'name',
  'description',
  'logoUrl',
  'coverUrl',
  'klydos',
];

export const KLYDO_MANDATORY_FIELDS = {
  name: 'Klydo Name',
  loopUrl: 'Klydo File',
  theme: {
    handsColor: 'Klydo Theme',
    backgroundColor: 'Klydo Theme',
    dialsColor: 'Klydo Theme',
    pendulumColor: 'Klydo Theme',
    pendulumRodColor: 'Klydo Theme',
  },
  strikesUrls: 'Strike Tone',
  chimesUrls: 'Chime',
} as const;
